// "Complete your loadout" cross-sell block for the cart drawer.
// Rule engine lives in lib/crosssell.js — this component only renders.
import { useEffect, useState } from "react";
import { useCart } from "../../state/cart";
import { crossSellHandles, fetchSuggestion } from "../../lib/crosssell";

const FMT = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
});
function money(n) {
        const v = Number(n);
        return Number.isFinite(v) ? FMT.format(v) : "—";
}

export default function CrossSell({ lines }) {
        const { addLine } = useCart();
        const handlesKey = crossSellHandles(lines).join(",");
        const [items, setItems] = useState([]);
        const [busyHandle, setBusyHandle] = useState(null);

        useEffect(() => {
                const handles = handlesKey ? handlesKey.split(",") : [];
                if (!handles.length) {
                        setItems([]);
                        return undefined;
                }
                let alive = true;
                (async () => {
                        const prods = await Promise.all(handles.map(fetchSuggestion));
                        if (alive) setItems(prods.filter((p) => p && p.variantId));
                })();
                return () => {
                        alive = false;
                };
        }, [handlesKey]);

        if (!items.length) return null;

        const onAdd = async (p) => {
                if (busyHandle) return;
                setBusyHandle(p.handle);
                const res = await addLine(p.variantId, { intent: "buy", addedFrom: "cartdrawer.crosssell.v1" });
                setBusyHandle(null);
                if (!res || !res.ok) setItems((prev) => prev.filter((x) => x.handle !== p.handle));
        };

        return (
                <div data-testid="cart-crosssell" className="mt-8">
                        <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-white/50">
                                Complete your loadout
                        </p>
                        <div className="mt-3 space-y-3">
                                {items.map((p) => (
                                        <div
                                                key={p.handle}
                                                data-testid="cart-crosssell-card"
                                                className="flex items-center gap-3 border border-white/10 px-3 py-2.5"
                                        >
                                                <div className="shrink-0 w-[48px] h-[48px] border border-white/10 bg-[#111] flex items-center justify-center overflow-hidden">
                                                        {p.image ? (
                                                                <img
                                                                        src={p.image}
                                                                        alt={p.title}
                                                                        loading="lazy"
                                                                        className="max-w-full max-h-full object-contain p-1"
                                                                />
                                                        ) : (
                                                                <span className="text-white/25 font-display text-[16px]">{p.title.slice(0, 1)}</span>
                                                        )}
                                                </div>
                                                <div className="flex-1 min-w-0">
                                                        <a
                                                                href={`/p/${p.handle}`}
                                                                className="block font-sans text-[13px] font-semibold text-white leading-tight truncate hover:text-[#FF9F1C] transition-colors"
                                                        >
                                                                {p.title}
                                                        </a>
                                                        <p className="mt-0.5 font-mono text-[11px] text-white/60 tabular-nums">
                                                                {money(p.price)}
                                                        </p>
                                                </div>
                                                <button
                                                        type="button"
                                                        data-testid={`cart-crosssell-add-${p.handle}`}
                                                        onClick={() => onAdd(p)}
                                                        disabled={busyHandle === p.handle}
                                                        className="shrink-0 border border-[#FF9F1C]/60 text-[#FF9F1C] hover:bg-[#FF9F1C] hover:text-[#0A0A0A] font-mono text-[10px] tracking-[0.16em] uppercase px-3 py-2 transition-colors disabled:opacity-50"
                                                >
                                                        {busyHandle === p.handle ? "Adding…" : "+ Add"}
                                                </button>
                                        </div>
                                ))}
                        </div>
                </div>
        );
}
